import React, { useState } from "react";
import styles from './popularProd.module.css';
import Brand1Slider from "./Brand1Slider";
import { Sparkles } from "lucide-react";

const PopularProd = ({ popproduct }) => {
  // Filter out any manufacturer tab named 'Hacked'
  const cleanPopProduct = popproduct?.filter(
    (tab) => tab?.manufacturer && !tab.manufacturer.toLowerCase().includes("hacked")
  );

  const defaultTab = cleanPopProduct?.[0]?.manufacturer;
  const [activeTab, setActiveTab] = useState(defaultTab);
  
  const currentTab = activeTab || defaultTab;
  const products = cleanPopProduct?.filter((tab) => tab.manufacturer === currentTab);

  return (
    <div className={styles.prodContainer}>
      {/* SECTION HEADER */}
      <div className={styles.prodHeader}>
        <div className={styles.badgeTag}>
          <Sparkles size={14} className={styles.badgeIcon} />
          <span>High Demand Components</span>
        </div>
        <h2 className={styles.title}>Popular Products</h2>
        <p className={styles.subtitle}>
          Browse top-performing electronic components selected based on global sourcing trends, real-time availability, and high engineering demand.
        </p>
      </div>

      {/* MANUFACTURER TABS / FILTER BAR */}
      {cleanPopProduct && cleanPopProduct.length > 0 && (
        <div className={styles.prodTabsWrapper}>
          <div className={styles.prodTabsContainer}>
            {cleanPopProduct.map((tab, idx) => {
              const manufacturerName = tab?.manufacturer || `Brand ${idx + 1}`;
              const isActive = currentTab === manufacturerName;
              return (
                <button
                  key={idx}
                  className={`${styles.prodtab} ${isActive ? styles.prodactiveTab : ''}`}
                  onClick={() => setActiveTab(manufacturerName)}
                >
                  <span>{manufacturerName}</span>
                  {isActive && <span className={styles.activeDot} />}
                </button>
              );
            })}
          </div>
        </div>
      )}

      {/* SLIDER / PRODUCT CONTENT */}
      <div className={styles.prodContent}>
        <div className={styles.section}>
          {products?.map((i, idx) => (
            <Brand1Slider key={idx} prod={i?.product} manufacturer={i?.manufacturer} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PopularProd;
